import { OfferzSimilarProducts } from "@/types/product";
import { Trans } from "@lingui/macro";
import { Box, Typography } from "@mui/material";
import Link from "next/link";
import React from "react";
import { v4 as uuidv4 } from "uuid";

interface IncrementsProps {
  offerzSimilarProducts: OfferzSimilarProducts[];
  seoUrl: string;
}

const Increments: React.FC<IncrementsProps> = ({ offerzSimilarProducts, seoUrl }) => {
  return (
    <Box data-testid="increments-section">
      <Typography variant="h6" sx={{ fontWeight: 600, mb: 1, mt: "30px" }}>
        <Trans>Increments</Trans>
      </Typography>
      <Box className="flex flex-wrap gap-2">
        {offerzSimilarProducts.map((similarProduct: OfferzSimilarProducts) => (
          <Link href={`/product/${similarProduct.seo_url}`} key={uuidv4()} prefetch={false}>
            <Box
              data-testid={`increments-option-${similarProduct.seo_url}`}
              sx={{
                cursor: "pointer",
                borderRadius: "8px",
                borderWidth: "1px",
                borderStyle: "solid",
                padding: "10px",
                color: similarProduct.seo_url === seoUrl ? "#000" : "rgba(0,0,0,0.6)",
                borderColor: similarProduct.seo_url === seoUrl ? "primary.main" : "#bcbfc1",
                backgroundColor:
                  similarProduct.seo_url === seoUrl ? "primary.light" : "transparent",
                transition: ".3s ease",
                "&:hover": {
                  backgroundColor: "primary.light",
                  borderColor: "primary.main",
                },
              }}
            >
              {similarProduct.title}
            </Box>
          </Link>
        ))}
      </Box>
    </Box>
  );
};

export default React.memo(Increments);
